import styled, {css} from "styled-components";

const Wrap = styled.div`
	width: 100%;
	margin: 60px auto 40px;
`;

const Tab = styled.ul`
	display: flex;
	margin-top: 10px;
	margin-bottom: 40px;
	border-bottom: 1px solid var(--line-color);
`;

const TabItem = styled.li<{active?: boolean}>`
	position: relative;
	display: flex;
	padding: 20px 0;
	&:not(:last-child) {
		margin-right: 30px;
	}
	font-size: var(--default-size);
	color: var(--gray-color);
	cursor: pointer;
	${props =>
		props.active
			? css`
					font-weight: bold;
					color: var(--emp-color);
					&::after {
						position: absolute;
						right: 0;
						bottom: -1px;
						z-index: 1;
						display: block;
						width: 100%;
						height: 3px;
						background-color: var(--yellow-color);
						content: "";
					}
			  `
			: ""}
`;

const HotelInfoWrap = styled.div<{active?: boolean}>`
	display: ${props => (props.active ? "block" : "none")};
	padding: 35px 40px 40px;
	border: 1px solid var(--line-color);

	> h4 {
		padding-bottom: 20px;
		margin-bottom: 20px;
		border-bottom: 1px dashed var(--line-color);
		font-size: var(--medium-size);
		color: var(--emp-color);
	}
`;

const TableWrap = styled.div`
	margin-top: 40px;
`;

export {HotelInfoWrap, Tab, TabItem, Wrap, TableWrap};
